var map = {
	"./config.acc.js": 1129,
	"./config.acc2.js": 1130,
	"./config.dev.js": 1131,
	"./config.local.js": 1132,
	"./config.prod.js": 1133,
	"./config.tst.js": 1134
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1128;